import React from 'react';
import { Box, Button, RadioGroup, FormControlLabel, Radio, FormControl, Select, MenuItem, InputLabel } from '@mui/material';
import { DriverSelectionConfig, DriverSelectionOption } from './DrivingQuestionsConfig';

interface DriverSelectionProps {
  config: DriverSelectionConfig;
  currentValue: boolean | null;
  onChange: (value: boolean, showsAdditionalDrivers: boolean) => void;
}

const DriverSelection: React.FC<DriverSelectionProps> = ({ config, currentValue, onChange }) => {
  const selectedOption = config.options.find(option => 
    option.showsAdditionalDrivers === false ? currentValue === true : currentValue === false
  );

  const handleChange = (option: DriverSelectionOption) => {
    const value = option.showsAdditionalDrivers ? false : true;
    onChange(value, option.showsAdditionalDrivers);
  };

  switch (config.type) {
    case 'buttons':
      return (
        <Box sx={{ 
          display: 'grid', 
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, 
          gap: 2, 
          mb: 2 
        }}>
          {config.options.map((option) => (
            <Button
              key={option.key}
              variant={
                (option.showsAdditionalDrivers ? currentValue === false : currentValue === true) 
                  ? "contained" 
                  : "outlined"
              }
              onClick={() => handleChange(option)}
              fullWidth
            >
              {option.text}
            </Button>
          ))}
        </Box>
      );

    case 'radio':
      return (
        <FormControl component="fieldset" sx={{ mb: 2 }}>
          <RadioGroup
            value={currentValue?.toString() || ''}
            onChange={(e) => {
              const value = e.target.value === 'true';
              const option = config.options.find(opt => 
                opt.showsAdditionalDrivers ? !value : value
              );
              if (option) {
                handleChange(option);
              }
            }}
          >
            {config.options.map((option) => (
              <FormControlLabel
                key={option.key}
                value={option.showsAdditionalDrivers ? 'false' : 'true'}
                control={<Radio />}
                label={option.text}
              />
            ))}
          </RadioGroup>
        </FormControl>
      );

    case 'dropdown':
      return (
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Select driver option</InputLabel>
          <Select
            value={currentValue !== null ? (currentValue ? 'true' : 'false') : ''}
            onChange={(e) => {
              const value = e.target.value === 'true';
              const option = config.options.find(opt => 
                opt.showsAdditionalDrivers ? !value : value
              );
              if (option) {
                handleChange(option);
              }
            }}
          >
            {config.options.map((option) => (
              <MenuItem key={option.key} value={option.showsAdditionalDrivers ? 'false' : 'true'}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );

    default:
      return null;
  }
};

export default DriverSelection;
